import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useResponsive, useRouteHook } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';
import { BaseSelect, OptionType } from '@shared/widgets';

interface MobileHeaderProps {
  className?: string;
  contentClassName?: string;
  children?: ReactNode;
  years?: OptionType[];
  value?: string;
  onChange?: (value: string | number) => void;
}

export const MobileHeader = (props: MobileHeaderProps) => {
  const { isMobile } = useResponsive();
  const { back } = useRouteHook();

  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    back();
  };

  return (
    <div className={clsx('max-[840px]:bg-[#27272b] flex items-center justify-between max-[840px]:h-12 max-[840px]:px-5', props.className)}>
      {isMobile && (
        <div className={clsx('flex justify-between items-center w-full', props.contentClassName)}>
          <a
            className={clsx(
              'text-base no-underline hover:text-[#f8f8f8] text-[16px] shrink-0',
              PaletteUtils.isBordierPalette ? 'text-[#dc291c] ' : 'text-[#E5C496]',
            )}
            href='#'
            onClick={handleClick}
          >
            <svg xmlns='http://www.w3.org/2000/svg' className='inline translate-x-0 translate-y-[-2px]' width='16' height='16' viewBox='0 0 16 16'>
              <path fill='currentColor' d='M12 14.25L6.405 8.5 12 2.75 10.297 1 3 8.5l7.297 7.5z' />
            </svg>
            {t('buttons.back')}
          </a>
          {props.years && (
            <BaseSelect
              values={props.years}
              value={props.value}
              onChange={(value) => props.onChange?.(Number(value))}
              className='!mb-2'
              selectClassName={clsx('!bg-transparent border-0 text-lg gap-4', PaletteUtils.isBordierPalette ? 'text-[#dc291c]' : 'text-[#e5c496]')}
            />
          )}
        </div>
      )}
      {props.children}
    </div>
  );
};
